import { Fragment } from "react";

import LegalPageContent from "../common/LegalPageContent";

const BookingTermsModal = () => {
  return (
    <Fragment>
      <LegalPageContent slug="booking-terms" />
    </Fragment>
  );
};

export default BookingTermsModal;
